
import { TokenStorage } from '@seedkit/vue-administration-module/public';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const securityWorker = <SecurityDataType = unknown>( securityData: SecurityDataType | null ) => {
  const token = TokenStorage.getAccessToken() ? `Bearer ${ TokenStorage.getAccessToken() }` : void 0;

  const result = {
    headers: { Authorization: token },
  };
  return result;
};

